import { RouterModule, Routes } from '@angular/router';
import { LoginCubeShopComponent } from './pages/login-v2/login-v2/login-cubeshop/login-cubeshop.component';
import { HomeComponent } from './pages/home/home.component';
import { ResponsiveComponent } from './pages/home/responsive/responsive.component'
import { LoginRecoverPasswdCSComponent } from './pages/login-v2/login-recover-passwd-cs/login-recover-passwd-cs.component';
import { RegisterCubeShopUserComponent } from './pages/login-v2/login-v2/create-cubeshop-user/register-cubeshop-user.component';

const APP_ROUTES: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginCubeShopComponent },
  { path: 'actPass', component: ResponsiveComponent },
  // { path: 'RecoverPassword', component: LoginRecoverPasswdComponent },
  { path: 'RecoverPasswordCS', component: LoginRecoverPasswdCSComponent },
  { path: 'createuser', component: RegisterCubeShopUserComponent },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./shared/shared-dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'salesProject',
    loadChildren: () => import('./pages/sales-management/sales-project/sales-project.module').then(m => m.SalesProjectModule)
  },
  {
    path: 'pipeline',
    loadChildren: () => import('./pages/sales-management/pipeline/pipeline.module').then(m => m.PipelineModule)
  },
  {
    path: 'salesLeads',
    loadChildren: () => import('./pages/sales-management/sales-leads/sales-lead.module').then(m => m.SalesLeadModule)
  },
  {
    path: 'contacts',
    loadChildren: () => import('./pages/sales-management/contacts/contacts.module').then(m => m.ContactsModule)
  },
  {
    path: 'customers',
    loadChildren: () => import('./pages/sales-management/customers/customers.module').then(m => m.CustomersModule)
  },
  {
    path: 'employeeActivity',
    loadChildren: () => import('./pages/sales-management/employee-activities/employee-activities.module').then(m => m.EmployeeActivitiesModule)
  },
  {
    path: 'salesanalysis',
    loadChildren: () => import('./pages/sales-management/sales-analysis/sales-analysis.module').then(m => m.SalesAnalysisModule)
  },
  {
    path: 'salesSite',
    loadChildren: () => import('./pages/sales-management/sales-site/sales-site.module').then(m => m.SalesSiteModule)
  },
  {
    path: 'Estimates',
    loadChildren: () => import('./pages/estimation/estimation.module').then(m => m.EstimationModule)
  },
  {
    path: 'taskManagement',
    loadChildren: './pages/project-management/task-management/task-management.module#TaskManagementModule'
  },
  {
    path: 'ganttScheduler',
    loadChildren: './pages/project-management/gantt-scheduler/gantt-scheduler.module#GanttSchedulerProjectModule'
  },
  {
    path: 'swo',
    loadChildren: './pages/service-management/service-work-order/service-work-order.module#ServiceWorkOrderModule'
  },
  {
    path: 'projectAnalysis',
    loadChildren: './pages/project-management/project-analysis/project-analysis.module#ProjectAnalysisModule'
  },
  {
    path: 'openRif',
    loadChildren: './pages/project-management/open-rif/open-rif.module#OpenRifModule'
  },
  {
    path: 'openPunchList',
    loadChildren: './pages/project-management/open-punch-list/open-punch-list.module#OpenPunchListModule'
  },
  {
    path: 'projects',
    loadChildren: './pages/project-management/projects/projects.module#ProjectsModule'
  },
  {
    path: 'myprojects',
    loadChildren: './pages/my-projects/my-projects.module#MyProjectsModule'
  },
  {
    path: 'commissioning',
    loadChildren: './pages/engineering/commissioning/commissioning.module#CommissioningModule'
  },
  {
    path: 'systemLibrary',
    loadChildren: './pages/engineering/system-library/system-library.module#SystemLibraryModule'
  },
  {
    path: 'myTrainings',
    loadChildren: './pages/home/my-trainings/my-trainings.module#MyTrainingsModule'
  },
  {
    path: 'pmUtility',
    loadChildren: './pages/service-management/pm-utility/pm-utility.module#PmUtilityModule'
  },
  {
    path: 'serviceSites',
    loadChildren: './pages/service-management/service-sites/service-sites.module#ServiceSitesModule'
  },
  {
    path: 'serviceContracts',
    loadChildren: './pages/service-management/service-contracts/service-contracts.module#ServiceContractsModule'
  },
  {
    path: 'serviceQuotes',
    loadChildren: './pages/service-management/service-quotes/service-quotes.module#ServiceQuotesModule'
  },
  {
    path: 'businessStrategy',
    loadChildren: './pages/management/business-strategy/business-strategy.module#BusinessStrategyModule'
  },
  {
    path: 'timeSheet',
    loadChildren: './pages/human-resources/time-sheet/time-sheet.module#TimeSheetModule'
  },
  {
    path: 'runPayroll',
    loadChildren: './pages/human-resources/run-payroll/run-payroll.module#RunPayrollModule'
  },
  {
    path: 'employeeDocuments',
    loadChildren: './pages/human-resources/employee-documents/employee-documents.module#EmployeeDocumentsModule'
  },
  {
    path: 'forms',
    loadChildren: './pages/human-resources/forms/forms.module#FormsModule'
  },
  {
    path: 'projectLaborAnalysis',
    loadChildren: './pages/project-management/project-labor-analysis/project-labor-analysis.module#ProjectLaborAnalysisModule'
  },
  {
    path: 'projectLaborProjection',
    loadChildren: './pages/project-management/project-labor-projection/project-labor-projection.module#ProjectLaborProjectionModule'
  },
  {
    path: 'cubeAdvertisement',
    loadChildren: 'src/app/pages/cube-settings/cube-advertisement/cube-advertisement.module#CubeAdvertisementModule'
  },
  {
    path: 'employees',
    loadChildren: './pages/human-resources/employees/employees.module#EmployeesModule'
  },
  {
    path: 'myTimeSheet',
    loadChildren: './pages/home/my-time-sheet/my-time-sheet.module#MyTimeSheetModule'
  },
  {
    path: 'Training',
    loadChildren: () => import('./pages/training-video/training-video.module').then(m => m.TrainingVideoModule)
  },
  {
    path: 'myExpenseReports',
    loadChildren: './pages/home/my-expense-reports/my-expense-reports.module#MyExpenseReportsModule'
  },
  {
    path: 'adminComponent',
    loadChildren: './pages/user-administration/administration-component-dashboard/administration-component-dashboard.module#AdministrationComponentDashboardModule'
  },
  {
    path: 'manageUsers',
    loadChildren: './pages/user-administration/manage-users/manage-users.module#ManageUsersModule'
  },
  {
    path: 'accountReceivable',
    loadChildren: './pages/accounting/account-receivable/account-receivable.module#AccountReceivableModule'
  },
  {
    path: 'purchaseOrder',
    loadChildren: './pages/inventory/purchase-order/purchase-order.module#PurchaseOrderModule'
  },
  {
    path: 'shipItems',
    loadChildren: './pages/inventory/ship-items/ship-items.module#ShipItemsModule'
  },
  {
    path: 'parts',
    loadChildren: './pages/inventory/parts/parts.module#PartsModule'
  },
  {
    path: 'subcontractor',
    loadChildren: './pages/inventory/subcontractor/subcontractor.module#SubcontractorModule'
  },
  {
    path: 'deltaWorld',
    loadChildren: './pages/engineering/delta-world/delta-world.module#DeltaWorldModule'
  },
  {
    path: 'prevailingWages',
    loadChildren: './pages/human-resources/prevailing-wages/prevailing-wages.module#PrevailingWagesModule'
  },
  {
    path: 'salesCommission',
    loadChildren: './pages/human-resources/sales-commissioning/sales-commissioning.module#SalesCommissioningModule'
  },
  {
    path: 'myTimeSheet',
    loadChildren: './pages/home/my-time-sheet/my-time-sheet.module#MyTimeSheetModule'
  },
  {
    path: 'myCommissions',
    loadChildren: './pages/home/my-commissions/my-commissions.module#MyCommissionsModule'
  },
  {
    path: 'mySchedule',
    // loadChildren: () => import('./pages/home/my-schedule/my-schedule.module').then(m => m.MyScheduleModule)
    loadChildren: './pages/home/my-schedule/my-schedule.module#MyScheduleModule'
  },
  {
    path: 'newActivity',
    loadChildren: './pages/home/new-activity/new-activity.module#NewActivityModule'
  },
  {
    path: 'myInformation',
    loadChildren: './pages/home/my-information/my-information.module#MyInformationModule'
  },
  {
    path: 'systemComponent',
    loadChildren: './pages/engineering/system-components/system-components.module#SystemComponentsModule'
  },
  {
    path: 'vendors',
    loadChildren: './pages/inventory/vendors/vendors.module#VendorsModule'
  },
  {
    path: 'reconcile',
    loadChildren: './pages/inventory/reconcile/reconcile.module#ReconcileModule'
  },
  {
    path: 'rma',
    loadChildren: './pages/inventory/rma/rma.module#RmaModule'
  },
  {
    path: 'serviceManagement',
    loadChildren: './pages/service-management/service-management/service-management.module#ServiceManagementModule'
  },
  {
    path: 'serviceReports',
    loadChildren: './pages/service-management/service-reports/service-reports.module#ServiceReportsModule'
  },
  {
    path: 'departments',
    loadChildren: './pages/management/departments/departments.module#DepartmentsModule'
  },
  {
    path: 'jobDescriptions',
    loadChildren: './pages/management/job-description/job-description.module#JobDescriptionModule'
  },
  {
    path: 'materialRequest',
    loadChildren: './pages/inventory/material-request/material-request.module#MaterialRequestModule'
  },
  {
    path: 'inventory',
    loadChildren: './pages/inventory/inventory/inventory.module#InventoryModule'
  },
  {
    path: 'trainings',
    loadChildren: './pages/education/trainings/trainings.module#TrainingsModule'
  },
  {
    path: 'creditManagement',
    loadChildren: './pages/accounting/credit-management/credit-management.module#CreditManagementModule'
  },
  {
    path: 'importCenter',
    loadChildren: './pages/cube-settings/import-center/import-center.module#ImportCenterModule'
  },
  {
    path: 'updateCenter',
    loadChildren: './pages/cube-settings/update-center/update-center.module#UpdateCenterModule'
  },
  {
    path: 'utilityTables',
    loadChildren: './pages/cube-settings/utility-tables/utility-tables.module#UtilityTablesModule'
  },
  {
    path: 'salesForecast',
    loadChildren: './pages/sales-management/sales-forecast/sales-forecast.module#SalesForecastModule'
  },
  {
    path: 'salesReports',
    loadChildren: './pages/sales-management/sales-reports/sales-reports.module#SalesReportsModule'
  },
  {
    path: 'reports/:departmentid',
    loadChildren: './shared/shared-reports/shared-reports.module#SharedReportsModule'
  },
  {
    path: 'marketAnalysis',
    loadChildren: './pages/sales-management/market-analysis/market-analysis.module#MarketAnalysisModule'
  },
  {
    path: 'marketingCampaign',
    loadChildren: './pages/sales-management/marketing-campaign/marketing-campaign.module#MarketingCampaignModule'
  },
  {
    path: 'integration',
    loadChildren: './pages/cube-settings/integration/integration.module#IntegrationModule'
  },
  {
    path: 'editProject',
    loadChildren: './pages/project-management/edit-project/edit-project.module#EditProjectModule'
  },
  {
    path: 'editRequisition',
    loadChildren: './pages/project-management/edit-requisition/edit-requisition.module#EditRequisitionModule'
  },
  {
    path: 'partCategories',
    loadChildren: './pages/inventory/part-categories/part-categories.module#PartCategoriesModule'
  },
  {
    path: 'editTechView',
    loadChildren: './pages/engineering/tech-view-delta/edit-tech-view/edit-tech-view.module#EditTechViewModule'
  },
  {
    path: 'configGrid',
    loadChildren: './pages/cube-settings/config-grid/config-grid.module#ConfigGridModule'
  },
  {
    path: 'services-map',
    loadChildren: './pages/service-management/services-map/map-service/services-map.module#ServicesMapModule'
  },
  {
    path: 'editIntegration',
    loadChildren: './pages/cube-settings/integration/edit-integration/edit-integration.module#EditIntegrationModule'
  },
  {
    path: 'editEstimate',
    loadChildren: './pages/estimation/edit-estimate/edit-estimate.module#EditEstimateModule'
  },
  {
    path: 'cubeMenu',
    loadChildren: './pages/admin-tools/cube-menu/cube-menu.module#CubeMenuModule'
  },
  {
    path: 'configureImageSVG',
    loadChildren: './pages/admin-tools/configure-image-svg/configure-image-svg.module#ConfigureImageSvgModule'
  },

  // {
  //   path: 'workFlowSummary',
  //   loadChildren: './pages/project-management/edit/work-flow-summary.module#WorkFlowSummaryModule'
  // },
  {
    path: 'workFlowSummary',
    loadChildren: './pages/project-management/work-flow-summary/work-flow-summary.module#WorkFlowSummaryModule'
  },
  {
    path: 'editOpenPunchList',
    loadChildren: './pages/project-management/open-punch-list/edit-open-punch-list/edit-open-punch-list.module#EditOpenPunchListModule'
  },
  {
    path: 'editRif',
    loadChildren: './pages/project-management/open-rif/edit-open-rif/edit-open-rif.module#EditOpenRifModule'
  },
  {
    path: 'editChangeOrder',
    loadChildren: './pages/project-management/edit-project/edit-change-order/edit-change-order.module#EditChangeOrderModule'
  },
  {
    path: 'vehicles',
    loadChildren: './pages/cube-settings/vehicles/vehicles.module#VehiclesModule'
  },
  {
    path: 'editVehicles',
    loadChildren: './pages/cube-settings/vehicles/edit-vehicles/edit-vehicles.module#EditVehiclesModule'
  },
  {
    path: 'recommendations',
    loadChildren: './pages/service-management/service-recommendations/service-recommendations.module#ServiceRecommendationsModule'
  },
  {
    path: 'home',
    loadChildren: './pages/home/home.module#HomeModule'
  },
  {
    path: 'engUtility',
    loadChildren: './pages/engineering/eng-utility/eng-utility.module#EngUtilityModule'
  },
  {
    path: 'groups/:id',
    loadChildren: './pages/user-administration/manage-users/groups/groups.module#GroupsModule'
  },
  {
    path: 'reportviewer',
    loadChildren: 'src/app/shared/report-viewer/report-viewer.module#ReportViewerModule'
  },
  {
    path: 'findReplace',
    loadChildren: './pages/engineering/system-components/find-and-replace/find-and-replace.module#FindAndReplaceModule'
  },
  {
    path: 'unlockUser',
    loadChildren: './pages/admin-tools/unlock-user/unlock-user.module#UnlockUserModule'
  },
  {
    path: 'cubeReleases',
    loadChildren: './pages/admin-tools/cube-releases/cube-releases.module#CubeReleasesModule'
  },
  {
    path: 'clientActivation',
    loadChildren: './pages/admin-tools/client-activation/client-activation.module#ClientActivationModule'
  },
  {
    path: 'responsive',
    loadChildren: './pages/home/responsive/responsive.module#ResponsiveModule'
  },
  {
    path: 'reportdesigner',
    loadChildren: 'src/app/shared/report-designer/report-designer.module#ReportDesignerModule'
  },
  {
    path: 'payment',
    loadChildren: './pages/login/payment/payment.module#PaymentModule'
  },
  {
    path: 'creditcard',
    loadChildren: './pages/login/creditcard/creditcard.module#CreditCardModule'
  },
  {
    path: 'companyNotification',
    loadChildren: './pages/cube-settings/company-notification/company-notification.module#CompanyNotificationModule'
  },
  {
    path: 'myWebinars',
    loadChildren: 'src/app/pages/start-here/my-webinars/my-webinars.module#MyWebinarsModule'
  },
  {
    path: 'customerWebinars',
    loadChildren: 'src/app/pages/cube-settings/customer-webinars/customer-webinars.module#CustomerWebinarsModule'
  },
  {
    path: 'taskCategory',
    loadChildren: 'src/app/pages/cube-settings/task-category-grid/task-category-grid.module#TaskCategoryGridModule'
  },
  {
    path: 'newAccount',
    loadChildren: 'src/app/pages/login-new-account/login-new-account.module#LoginNewAccountModule'
  },
  {
    path: 'editTransfers',
    loadChildren: 'src/app/pages/inventory/inventory/edit-transfers/edit-transfers.module#EditTransfersModule'
  },
  {
    path: 'editLocationGroup',
    loadChildren: 'src/app/pages/inventory/inventory/edit-location-group/edit-location-group.module#EditLocationGroupModule'
  },
  {
    path: 'editRMA',
    loadChildren: 'src/app/pages/inventory/rma/edit-rma/edit-rma.module#EditRmaModule'
  },
  {
    path: 'editCredit',
    loadChildren: 'src/app/pages/accounting/credit-management/edit-credit-management/edit-credit-management.module#EditCreditManagementModule'
  },
  {
    path: 'kbs',
    loadChildren: 'src/app/pages/education/kbs/kbs.module#KbsModule'
  },
  {
    path: 'editkbas',
    loadChildren: 'src/app/pages/education/kbs/edit-kbas/edit-kbas.module#EditKBAsModule'
  },
  {
    path: 'productsCart',
    loadChildren: 'src/app/pages/shop/products-cart/products-cart.module#ProductsCartModule'
  },
  {
    path: 'productsCategory',
    loadChildren: 'src/app/pages/shop/products-category/products-category.module#ProductsCategoryModule'
  },
  {
    path: 'products',
    loadChildren: 'src/app/pages/shop/products/products.module#productsModule'
  },
  {
    path: 'ApplicationType',
    loadChildren: 'src/app/pages/shop/application-type/application-type.module#ApplicationTypeModule'
  },
  {
    path: 'ListSystems',
    loadChildren: 'src/app/pages/shop/list-systems/list-systems.module#ListSystemsModule'
  },
  {
    path: 'externaluser',
    loadChildren: './pages/login/register-external-user/register-externa-user.module#RegisterExternaUserModule'
  },
  {
    path: 'productsDetails',
    loadChildren: 'src/app/pages/shop/products-details/products-details.module#ProductsDetailsModule'
  },
  {
    path: 'registerCompany',
    loadChildren: './pages/login/register-external-user/register-externa-user.module#RegisterExternaUserModule'
  },
  {
    path: 'companyRegistration',
    loadChildren: './pages/login/company-registration/company-registration.module#CompanyRegistrationModule'
  },
  {
    path: 'paymentCart',
    loadChildren: 'src/app/pages/shop/payment-information/payment-information.module#PaymentInformationModule'
  },
  {
    path: 'newPayment',
    loadChildren: 'src/app/pages/shop/add-new-payment/add-new-payment.module#AddNewPaymentModule'
  },
  {
    path: 'shippingAddress',
    loadChildren: 'src/app/pages/shop/shipping-address/shipping-address.module#ShippingAddressModule'
  },
  {
    path: 'newShippingAddress',
    loadChildren: 'src/app/pages/shop/add-new-shipping/add-new-shipping.module#AddNewShippingModule'
  },
  {
    path: 'order',
    loadChildren: 'src/app/pages/shop/order/order.module#OrderModule'
  },
  {
    path: 'orderDetail',
    loadChildren: 'src/app/pages/shop/order-detail/order-detail.module#OrderDetailModule'
  },
  {
    path: 'applications',
    loadChildren: 'src/app/pages/shop/applications/applications.module#ApplicationsModule'
  },
  {
    path: 'MyProjects',
    loadChildren: 'src/app/pages/shop/my-projects/my-projects.module#MyProjectsModule'
  },
  {
    path: 'DetailProject',
    loadChildren: 'src/app/pages/shop/detail-project/detail-project.module#DetailProjectModule'
  },
  {
    path: 'yourOrder',
    loadChildren: 'src/app/pages/shop/your-order/your-order.module#YourOrderModule'
  },
  {
    path: 'myCart',
    loadChildren: 'src/app/pages/shop/my-cart/my-cart.module#MyCartModule'
  },
  {
    path: 'editExpenseReports',
    loadChildren: './pages/home/my-expense-reports/edit-expense-reports/edit-expense-reports.module#EditExpenseReportsModule'
  },
  {
    path: 'systemlog',
    loadChildren: './pages/admin-tools/system-log/system-log.module#SystemLogModule'
  },
  {
    path: 'projectpart',
    loadChildren: './pages/project-management/projectpart/projectsparts.module#ProjectsPartsModule'
  },
  {
    path: 'reports',
    loadChildren: 'src/app/shared/reports/reports.module#ReportsModule'
  },
  {
    path: 'my-account',
    loadChildren: 'src/app/pages/user-administration/my-account/my-account.module#MyAccountModule'
  },
  {
    path: 'editPayment',
    loadChildren: 'src/app/pages/user-administration/my-account/edit-payment-method/edit-payment-method.module#EditPaymentMethodModule'
  },
  {
    path: 'getMyToken',
    loadChildren: 'src/app/pages/user-administration/gettoken/gettoken.module#GettokenModule'
  },

  //cube work
  {
    path: 'searchJobs',
    loadChildren: 'src/app/pages/cubeWork/search-job/search-job.module#SearchJobModule'
  },
  {
    path: 'myFeed',
    loadChildren: 'src/app/pages/cubeWork/my-feed/my-feed.module#MyFeedModule'
  },
  {
    path: 'clientDashboard',
    loadChildren: 'src/app/pages/cubeWork/client-dasboard/client-dasboard.module#ClientDasboardModule'
  },
  {
    path: 'jobPost',
    loadChildren: 'src/app/pages/cubeWork/job-post/job-post.module#JobPostModule'
  },
  {
    path: 'contracts',
    loadChildren: 'src/app/pages/cubeWork/contracts/contracts.module#ContractsModule'
  },
  {
    path: 'jobs',
    loadChildren: 'src/app/pages/cubeWork/jobs/jobs.module#JobsModule'
  },
  {
    path: 'reviewPost',
    loadChildren: 'src/app/pages/cubeWork/review-post/review-post.module#ReviewPostModule'
  },
  {
    path: 'reportsWork',
    loadChildren: 'src/app/pages/cubeWork/reports-work-cube/reports-work-cube.module#ReportsWorkCubeModule'
  },
  {
    path: 'settings',
    loadChildren: 'src/app/pages/cubeWork/settings-cube-work/settings-cube-work.module#SettingsCubeWorkModule'
  },
  {
    path: 'profileTalent',
    loadChildren: 'src/app/pages/cubeWork/profile-talent/profile-talent.module#ProfileTalentModule'
  },
  {
    path: 'myProposals',
    loadChildren: 'src/app/pages/cubeWork/my-proposals/my-proposals.module#MyProposalsModule'
  },
  {
    path: 'findWork',
    loadChildren: 'src/app/pages/cubeWork/find-work/find-work.module#FindWorkModule'
  },
  {
    path: 'offerView',
    loadChildren: 'src/app/pages/cubeWork/offer-view/offer-view.module#OfferViewModule'
  },
  {
    path: 'myJobs',
    loadChildren: 'src/app/pages/cubeWork/my-jobs/my-jobs.module#MyJobsModule'
  },
  {
    path: 'detailsJobs',
    loadChildren: 'src/app/pages/cubeWork/my-jobs-details/my-jobs-details.module#MyJobsDetailsModule'
  },
  {
    path: 'cs-portal',
    loadChildren: './pages/cs-portal/cs-portal.module#CsPortalModule'
  },
  {
    path: 'cs-serviceSite',
    loadChildren: './pages/cs-portal/cs-service-sites/cs-service-sites.module#CsServiceSitesModule'
  },
  {
    path: 'cs-activeProjects',
    loadChildren: './pages/cs-portal/cs-active-projects/cs-active-projects.module#CsActiveProjectsModule'
  },
  {
    path: 'cs-editServiceSites',
    loadChildren: './pages/cs-portal/cs-edit-service-sites/cs-edit-service-sites.module#CsEditServiceSitesModule'
  },
  {
    path: 'cs-serviceHistory',
    loadChildren: './pages/cs-portal/cs-service-history/cs-service-history.module#CsServiceHistoryModule'
  },

  {
    path: 'partList',
    loadChildren: './pages/admin-tools/admin-eng-utility/admin-eng-utility.module#AdminEngUtilityModule'
  },

  {
    path: 'engUtilityMaster',
    loadChildren: './pages/admin-tools/admin-eng-utility/admin-eng-utility.module#AdminEngUtilityModule'
  },

];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES);
